export default {
  primary: "#6c63ff",
  primaryOverlay: "efeeff",
  buttonColor: "#0074d9",
  buttonColorSecondary: "#001F3F"
};
